import actions from "./actions.js";
import mutations from "./mutations.js";

export const notificationsModule = {
  state: {
    pendingNotifications: [],
    currentNotification: {}
  },
  namespaced: true,
  getters: {},
  actions,
  mutations
};
